// 계정 화면의 환불 요청 상태 문구(ExpandedAccountDetails 에서 옮김)와 "환불 진행 중" 판정.
import { formatSubscriptionStatus } from './paymentStatusLabels';

const IN_PROGRESS = new Set(['PENDING', 'APPROVED', 'PROVIDER_PENDING']);

/** 결제사가 확정하기 전의 환불(검토 대기·승인됨·Paddle 승인 대기). */
export const isAdminRefundRequestInProgress = (status: string | null | undefined): boolean => (
  Boolean(status && IN_PROGRESS.has(status.trim().toUpperCase()))
);

export function formatRefundRequestStatus(value: string): string {
  switch (value.trim().toUpperCase()) {
    case 'PENDING':
      return '대기';
    case 'APPROVED':
      return '승인됨 · 처리 전';
    case 'PROVIDER_PENDING':
      return 'Paddle 승인 대기';
    case 'PROCESSING':
      return '처리 중';
    case 'FAILED':
      return '실패';
    case 'PROCESSED':
    case 'COMPLETED':
      return '처리 완료';
    case 'REJECTED':
      return '거절';
    default:
      return formatSubscriptionStatus(value);
  }
}
